import version from 'src/version';

const config = {
  version: version,
  env: 'LIVE',
  app: {
    defaultLang: 'en_CA',
  },
  api: {
    apiMms: {
      URL: 'https://mms-bell.sbeglobalcare.com/backend/',
    },
  },
};

export default config;
